import { render } from "./NewRecovery.vue?vue&type=template&id=5e706482"
import script from "./NewRecovery.vue?vue&type=script&lang=js"
export * from "./NewRecovery.vue?vue&type=script&lang=js"
script.render = render

export default script